import React, { useEffect, useRef, useState } from 'react';
import queryString from 'query-string';
import OftadehLayout from '../../components/OftadehLayout/OftadehLayout';
import { Button, Grid, makeStyles, Typography } from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import swal from '@sweetalert/with-react';
import CardContent from '@material-ui/core/CardContent';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import SaveIcon from '@material-ui/icons/Save';
import ListIcon from '@material-ui/icons/List';
import DeleteIcon from '@material-ui/icons/Delete';
import axiosInstance from '../../constants/AxiosInstance';
import { API_URL, getTypeName, NOTICE_CATEGORY } from '../../constants';
import { getNoticeInfo } from '../../constants/PromiseHttp';
import ImgListView from '../customComp/ImgListView';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    color: '#3f51b5',
  },
  bigTitle: {
    fontWeight: 'bold', // 글씨 굵게
    fontSize: '24px', // 글씨 크기 조정
    // borderBottom: '2px solid #000',  // 언더라인 추가
    // paddingBottom: '10px',   // 텍스트와 언더라인 사이의 간격
    // marginBottom: '10px',   // 아래의 텍스트와 간격
  },
  timeStamp: {
    color: '#8b8c8d',
    fontSize: '10px',
    borderBottom: '1px solid #000', // 언더라인 추가
    paddingBottom: '10px', // 텍스트와 언더라인 사이의 간격
    marginBottom: '0px', // 아래의 텍스트와 간격
  },
  my3: {
    margin: '1.3rem 0',
  },
}));

const NoticeDetailPage = (props) => {
  const query = queryString.parse(props.location.search);
  const type = query.type ? query.type : 'new';
  const IS_SYS_ADMIN = sessionStorage.getItem('bt_role') === 'SYS_ADM';

  const [notice, setNotice] = useState({});

  const { history } = props;
  const classes = useStyles();

  useEffect(() => {
    if (type === 'edit' && query.id) {
      getData();
    } else {
      setNotice([]);
    }
  }, []);

  const getData = () => {
    getNoticeInfo(query.id).then((result) => {
      setNotice(result);
    });
  };

  const deleteNotice = () => {
    swal({
      title: 'Are you sure you want to delete?',
      text: '',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axiosInstance.delete(`${API_URL}/notice/${query.id}`, { headers: { Pragma: 'no-cache' } }).then((response) => {
          if (response.status === 200) {
            swal('It is deleted.', {
              icon: 'success',
            });
            goList();
          }
        });
      } else {
      }
    });
  };

  const goList = () => {
    history.push('/pages/notice/');
  };

  const goEdit = () => {
    history.push(`/pages/notice/edit?type=edit&id=${query.id}`);
  };

  return (
    <OftadehLayout>
      <Grid container className={classes.my3} alignItems="center">
        <Grid item className={classes.mRight} style={{ fontWeight: 'bold' }}>
          <Typography variant="h5" component="h1" style={{ fontWeight: 'bold' }}>
            Notice Detail
          </Typography>
        </Grid>
      </Grid>

      <Card className={classes.root}>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} mb={12}>
              <div className={classes.title}>[ {getTypeName(NOTICE_CATEGORY, notice.category)} ]</div>
              <div className={classes.bigTitle}>{notice.title}</div>
              <div className={classes.timeStamp}>{moment(Number(notice.createdAt)).format('YYYY-MM-DD HH:mm')}</div>
            </Grid>
            <Grid item xs={12}>
              <ImgListView images={notice && notice.files} hideFileName={true} />
            </Grid>
            <Grid item xs={12} mb={6}>
              <div dangerouslySetInnerHTML={{ __html: notice.contents }} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Grid container justifyContent={'space-between'} item xs={12} md={12} spacing={3} style={{ marginTop: '10px' }}>
        <Grid item>
          <Button
            variant="contained"
            style={{ backgroundColor: green[700], color: '#ffffff', marginRight: '10px' }}
            size="medium"
            onClick={goList}
            startIcon={<ListIcon />}
          >
            List
          </Button>
          {IS_SYS_ADMIN && type !== 'new' ? (
            <Button variant="contained" color="secondary" size="medium" onClick={deleteNotice} startIcon={<DeleteIcon />}>
              Delete
            </Button>
          ) : null}
        </Grid>

        {IS_SYS_ADMIN && (
          <Grid item>
            <Button variant="contained" color="primary" size="medium" onClick={goEdit} startIcon={<SaveIcon />}>
              Edit
            </Button>
          </Grid>
        )}
      </Grid>
    </OftadehLayout>
  );
};

export default NoticeDetailPage;
